import axios from 'axios'
import { handleResponse, handleError } from '../helpers/api'
import store from '../store'

const apiRulesClient = axios.create({
  baseURL: `${window.config.VUE_APP_API_BASE_URL}/Rule`,
  withCredentials: true
})

export const rulesService = {
  getRules,
  saveRule,
  updateRule,
  deleteRule,
  getRulesNameList,
  getRuleByName
}

async function getRules() {
  return await apiRulesClient
    .get('/', getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function saveRule(payload) {
  return await apiRulesClient
    .post('/', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function deleteRule(payload) {
  return await apiRulesClient
    .delete('/' + payload.id, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function updateRule(payload) {
  return await apiRulesClient
    .put('/' + payload.id, payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

function getRulesNameList() {
  const ruleNameList = []
  store.getters.rules.forEach(rule => ruleNameList.push(rule.ruleName))
  return ruleNameList
}

function getRuleByName(rulename) {
  let returnValue = {}
  store.getters.rules.forEach(rule => {
    if (rule.ruleName === rulename) {
      returnValue = rule
    }
  })
  return returnValue
}

function getHeader() {
  return {
    headers: { Authorization: 'bearer ' + store.getters.jwtToken }
  }
}
